"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_apollo_1 = require("react-apollo");
const usersQuery = require("./user-search.query.graphql");
const flag_1 = require("../flag");
const helpers_1 = require("./helpers");
const util_1 = require("util");
const utilities_1 = require("../utilities");
const AkSpinner = require("@atlaskit/spinner").default;
const AkSingleSelect = require("@atlaskit/single-select").default;
const AkMultiSelect = require("@atlaskit/multi-select").default;
class State {
}
class UserSearch extends React.Component {
    constructor(props) {
        super(props);
        this.searchUsers = (input) => __awaiter(this, void 0, void 0, function* () {
            input = input.trim();
            let un = helpers_1.parseUsername(input);
            if (un != "") {
                input = un;
            }
            let errs = helpers_1.checkValidName(input);
            if (errs) {
                this.setState({ invalidMessage: errs });
                return;
            }
            if (input) {
                this.setState({
                    querying: true,
                    showSpinner: true,
                    curInput: input,
                    invalidMessage: ""
                });
                let result = yield this.props.data.refetch({
                    query: input,
                    skip: false
                });
                if (result && result.errors) {
                    let errMsg = "";
                    result.errors.map(err => {
                        errMsg += err.message + " ";
                    });
                    errMsg = errMsg.trim();
                    this.props.showFlag({ type: "error", title: "Error", message: errMsg });
                    // logger.error(errMsg);
                }
                this.setState({ querying: false, showSpinner: false });
            }
        });
        this.selectUser = (event) => {
            if (this.props.onChange) {
                let selectedNames = event.item ? [event.item] : event.items;
                this.props.onChange(selectedNames.map((option) => option.value));
            }
        };
        this.state = {
            curInput: "",
            querying: false,
            invalidMessage: ""
        };
    }
    render() {
        let { defaultUsers, disabled, required, placeholder, invalidMessage, multiSelect, label } = this.props;
        let users = this.props.data.users ? this.props.data.users : [];
        const displayUserInfo = this.props.displayUserInfo || helpers_1.displayUserInfo;
        let defaultSelected = [];
        let userOptions = [];
        users.forEach(user => {
            let newOption = {
                content: displayUserInfo(user),
                value: user.username,
                filterValues: [
                    user.username || user.id,
                    user.displayName,
                    user.email,
                    helpers_1.getUserFullName(user)
                ].filter(function (value) {
                    return !util_1.isNullOrUndefined(value);
                })
            };
            userOptions.push(newOption);
        });
        if (defaultUsers) {
            defaultUsers.forEach(user => {
                let newOption = {
                    content: displayUserInfo(user),
                    value: user.username,
                    filterValues: [
                        user.username || user.id,
                        user.displayName,
                        user.email,
                        helpers_1.getUserFullName(user)
                    ].filter(function (value) {
                        return !util_1.isNullOrUndefined(value);
                    })
                };
                defaultSelected.push(newOption);
            });
        }
        let errMsg = "";
        if (invalidMessage) {
            errMsg += invalidMessage + " ";
        }
        if (this.state.invalidMessage) {
            errMsg += this.state.invalidMessage;
        }
        errMsg = errMsg.trim();
        if (multiSelect) {
            return (React.createElement(AkMultiSelect, { hasAutocomplete: true, shouldFitContainer: true, filterValue: this.state.curInput, isDisabled: disabled, placeholder: placeholder, isInvalid: errMsg, invalidMessage: errMsg, isRequired: required, onSelectedChange: this.selectUser, noMatchesFound: this.state.showSpinner ? (React.createElement(AkSpinner, { size: "small", isCompleting: false })) : (undefined), onFilterChange: this.searchUsers, label: label, items: [{ items: !this.state.querying ? userOptions : [] }], defaultSelected: defaultSelected, selectedItem: defaultSelected }));
        }
        return (React.createElement(AkSingleSelect, { hasAutocomplete: true, shouldFitContainer: true, filterValue: this.state.curInput, isDisabled: disabled, placeholder: placeholder, isInvalid: errMsg, invalidMessage: errMsg, isRequired: required, onSelected: this.selectUser, noMatchesFound: this.state.showSpinner ? (React.createElement(AkSpinner, { size: "small", isCompleting: false })) : (undefined), onFilterChange: this.searchUsers, label: label, items: [{ items: !this.state.querying ? userOptions : [] }], defaultSelected: defaultSelected[0], selectedItem: defaultSelected[0] }));
    }
}
exports.UserSearch = UserSearch;
exports.UserSearchField = utilities_1.compose(react_apollo_1.graphql(usersQuery, {
    options: () => ({
        errorPolicy: "all",
        context: {
            debounceKey: "UserSearchProps"
        },
        variables: {
            query: "",
            skip: true
        }
    })
}), flag_1.withShowFlag)(UserSearch);
exports.UserSearchField.displayName = "UserSearchField";
